import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    Button,
    Divider,
    Box,
    CardMedia,
    createTheme,
    ThemeProvider,
} from '@mui/material';
import moment from 'moment'; 
import Footer from '../navbar/Footer';

const recentBulletinsData = [
    {
        title: 'Bulletin mensuel des prix pour le mois janvier 2025',
        link: '/documents/Bulletins/BUL01-2025.pdf',
        date: new Date('2025-02-15'),
        datePublication: new Date('2024-01-30'), 
        image: 'assets/Bulletins/bull_comm_ext_2016_1tri.PNG',
        description: 'Le bulletin de janvier 2025 présente l’inflation en moyenne annuelle du mois de janvier 2025 s’élève à +22,0% contre +20,2% le mois de décembre 2024.',
    },
];

function BulletinRecent() {
    const navigate = useNavigate();
    const theme = createTheme({
        palette: {
            primary: {
                main: '#388E3C',
            },
            secondary: {
                main: '#f50057',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 'bold',
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.03)',
                            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
                        },
                    },
                },
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
                <NavigationBar />
                <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
                    <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
                        Bulletin Récent
                    </Typography>
                    <Divider style={{ margin: '20px 0' }} />

                    <Grid container spacing={1} style={{ marginTop: '10px' }}>
                        {recentBulletinsData.map((bulletin, index) => (
                            <Grid item xs={12} sm={6} md={12} key={index}>
                                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 151, height: 200, m: 2, cursor: 'pointer' }}
                                            image={bulletin.image}
                                            alt={bulletin.title}
                                            onClick={() => window.open(bulletin.link, '_blank')}
                                        />
                                        <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                                                <a
                                                    href={bulletin.link}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {<DownloadIcon />}{bulletin.title}
                                                </a>
                                            </Typography>
                                            <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                {bulletin.description}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                {moment(bulletin.date).format('MMMM YYYY')}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Publié le : {moment(bulletin.datePublication).format('DD/MM/YYYY')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

<Box display="flex" justifyContent="flex-start" alignItems="center">
    <Button
        onClick={() => navigate('/bulletinsPrix')}
        style={{
            marginBottom:'30px', marginTop:'30px',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        }}
    >
        <ArrowForwardIcon style={{ marginRight: '8px' }} />  {/* Icône changée ici */}
        Aller à la page des Bulletins mensuels des prix
    </Button>
</Box>
                </Container>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default BulletinRecent;